import React, {useRef, useEffect} from 'react';
import "./Quote.sass";
import renderHTML from 'react-render-html';

const Quote = ({data}) => {
    let quote = useRef();

    return (
        <div
            id={data.id}
            ref={(el) => (quote = el)}
            style={data.style || {}}
            className={`Quote ${(data.color === "white") ? "white" : ""} ${data.classNames || ''}`}>
            <div className="image-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 40.93 31.91">
                    <g id="left_inverted_quote"
                       data-name="left_inverted_quote">
                        <path fill={data.color ? data.color : "#000000"}
                              d="M40.93,13.61v18.3H22.24v-18L29.12,0h9.14L32.52,12q-.87,1.65.6,1.65Zm-22.24,0v18.3H0v-18L6.87,0H16L10.28,12q-.87,1.65.6,1.65Z"/>
                    </g>
                </svg>
            </div>
            {renderHTML(data.content)}
            <div className="image-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 40.93 31.91">
                    <g id="right_quote"
                       data-name="right_quote">
                        <path fill={data.color ? data.color : "#000000"}
                              d="M0,18.31V0H18.68V18L11.81,31.91H2.67L8.41,20q.87-1.65-.6-1.65Zm22.24,0V0H40.93V18L34.05,31.91H24.91L30.65,20q.87-1.65-.6-1.65Z"/>
                    </g>
                </svg>
            </div>
        </div>

    );
};

export default Quote;